import { Container, Text, Progress } from '@chakra-ui/react';

const MessageBatchProgressDrawer = ({ cell }) => {
  const original = cell?.row?.original ??
    cell?.original ?? {
      id: '',
      status: '',
      progress: null,
    };

  const processed = original?.progress?.processed;
  const total = original?.progress?.total;
  const hasProgress =
    typeof processed === 'number' && typeof total === 'number' && total > 0;
  const percent = hasProgress ? (processed / total) * 100 : 1;
  const verb = original.status === 'sending' ? 'sent' : 'processed';

  return (
    <Container width="full">
      <Text textAlign="center" mb={4}>
        We're working hard behind the scenes... <br />
        {hasProgress ? `[${processed}] of [${total}] messages ${verb}` : null}
      </Text>
      <Progress value={percent} colorScheme="green" borderRadius={4} />
    </Container>
  );
};

export default MessageBatchProgressDrawer;
